import React, {
  useState,
  useEffect,
  useRef,
  memo,
  useLayoutEffect,
} from "react";
import { CKEditor } from "ckeditor4-react";
import DocumentLinkDialog from "./dialogs/DocumentLinkDialog";
import AttachFileDialog from "./dialogs/AttachFileDialog";
import CustomFieldsDialog from "./dialogs/CustomFieldsDialog";
import GlobalAttachmentsDialog from "./dialogs/GlobalAttachmentsDialog";

import { CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import shortid from "shortid";
import { attachmentClient } from "../../AxiosClient";
// import pdfjsLib from "@bundled-es-modules/pdfjs-dist/build/pdf";
// import viewer from "@bundled-es-modules/pdfjs-dist/web/pdf_viewer";
import "../pdfviewer.css";
import { connect } from "react-redux";
import {
  addOpen,
  removeOpen,
  editorFocused,
} from "../../redux/actions/editorActions";
import ChartGeneratorDialog from "./dialogs/ChartGeneratorDialog";
import QueryParametersDialog from "./dialogs/QueryParametersDialog";
import Chart from "chart.js";
import "chartjs-plugin-colorschemes";
import "./util/table.css";
import { getChartData, getColours } from "./util/ChartUtils";
import Dialog from "@material-ui/core/Dialog";
import {
  setTempId,
  setCustomFields,
  deleteCustomField,
} from "../../redux/actions/customFieldsActions";
import CreateCustomField from "../customfields/CreateCustomField";
import moment from "moment";
//import pdfjsWorker from "@bundled-es-modules/pdfjs-dist/build/pdf.worker.entry";
import MomentUtils from "@date-io/moment";
import { useTranslation } from "react-i18next";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import Alert from "@material-ui/lab/Alert";
import * as Utils from "../template/htmldiff/Utils";
import Highlight from 'react-highlight'


var PdfjsWorker = require("worker-loader?esModule=false!pdfjs-dist/build/pdf.worker.js"); // eslint-disable-line
var pdfjsLib = require("pdfjs-dist/build/pdf");
var viewer = require("pdfjs-dist/web/pdf_viewer");

// pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

CKEditor.editorUrl = process.env.PUBLIC_URL + "/ckeditor/ckeditor.js";

function KpsEditor(props) {
  const myElement = useRef();
  const [editorId, setEditorId] = useState(shortid.generate());
  const [videoAttachments, setVideoAttachments] = useState([]);
  const [imageAttachments, setImageAttachments] = useState([]);
  const [pdfAttachments, setPdfAttachments] = useState([]);
  const [downloadAttachments, setDownloadAttachments] = useState([]);
  const [hasCustomFieldsChange, setHasCustomFieldsChange] = useState(false);

  const [data, setData] = useState("<p></p>");
  const [loading, setLoading] = useState(true);
  const [documentDialogOpen, setDocumentDialogOpen] = useState(false);
  const [customFieldsDialogOpen, setCustomFieldsDialogOpen] = useState(false);
  const [globalAttachmentsOpen, setGlobalAttachmentsOpen] = useState(false);
  const [customFieldSelected, setCustomFieldSelected] = useState([]);
  const [documentLinkEdit, setDocumentLinkEdit] = useState(null);
  const [customFieldsEdit, setCustomFieldsEdit] = useState(null);
  const [attachFileOpen, setAttachFileOpen] = useState(false);
  const [editor, setEditor] = useState(null);
  const [reportDialogOpen, setReportDialogOpen] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const apiLocation = useSelector((state) => state.setting.apiLocation);
  const [reportEdit, setReportEdit] = useState(null);
  const [queryParametersOpen, setQueryParametersOpen] = useState(false);
  const [chartToQuery, setChartToQuery] = useState(null);
  const { t } = useTranslation();
  const sortAscSvg =
    "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z";
  const sortDescSvg =
    "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z";
  const refreshSvg =
    "M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z";
  const filterSvg =
    "M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z";

  useEffect(
    () => {
      if (editor) {
        editor.balloonToolbars.create({
          buttons: "Link,Unlink,Image",
          widgets: "image",
        });
      }
    },
    [editor]
  );

  // useEffect(() => {
  //   props.initialContent &&
  //     props.initialContent != data &&
  //     setData(props.initialContent);
  // });

  useEffect(
    () => {
      checkForAttachmentIds();
    },
    [data]
  );

  useEffect(
    () => {
      
      let elements = null;
      let hasChanged = false;
      let div;
      props.currentCustomFields.map((cf) => {
        if (editor && editor.document) {
          elements = editor.document.$.getElementsByName(
            "customfield-" + cf.tempId
          );
        } else {
          div = document.getElementById(`editor-${editorId}`);
          elements = document.getElementsByName("customfield-" + cf.tempId);
        }
        let value = "";
        if (cf.fieldType === "date") {
          if (cf.value) {
            value = moment(cf.value).format("DD/MM/YYYY");
          }
        } else if (cf.fieldType === "multiselect") {
          if (cf.value) {
            let array = JSON.parse(cf.value);
            array.map((item, idx) => {
              value = value + item;
              if (idx + 1 != array.length) {
                value = value + ", ";
              }
            });
          }
        } else {
          value = cf.value;
        }
        if (elements != null) {
          for (let i = 0; i < elements.length; i++) {
            if((div && div.contains(elements[i])) || editor){
              let text = "";
              if (elements[i].className.includes("Label")) {
                text = cf.name;
              } else if (elements[i].className.includes("Value")) {
                text = value;
              } else {
                text = `${cf.name}:${value}`;
              }
              if(elements[i].innerText != text){
                elements[i].innerText = text;
                hasChanged=true;
                setHasCustomFieldsChange(true);
              }
            }
          }
        }
      });
      if (editor && hasChanged) {
        onChange({ editor }, hasChanged);
        // if (props.onChange && elements != null && elements.length > 0) {
        //   propsOnChange(editor.getData());
        // }
      } else {
        let div = document.getElementById(`editor-${editorId}`);
        if (div && hasChanged) {
          onChange(div.innerHTML, hasChanged);
          // if (props.onChange && elements != null && elements.length > 0) {
          //   propsOnChange(div.innerHTML);
          // }
          // setTempContent(div.innerHTML);
        } else {
          // setNeedsToCallOnChange(true);
        }
      }
      // setNeedsToCallOnChange(true);
    },
    [props.currentCustomFields]
  );
  useEffect(
    () => {
      if (reportEdit) {
        setReportDialogOpen(true);
      }
    },
    [reportEdit]
  );

  useEffect(
    () => {
      if (firstLoad && data) {
        if (props.initialContent && data === props.initialContent) {
          setFirstLoad(false);
          getPdfsForContent();
          processDownloadLinks();
          if(props.customFields) props.setCustomFields(props.customFields);
        }
      } else {
        if (props.editSection) {
          props.editSection(data);
        }
        processAPILocation(data, true);
        //processAccessToken(data);
        processDownloadLinks();
        if(props.customFields) props.setCustomFields(props.customFields);
      }
      if (data && data.includes("chart-uninitialized")) {
        processCharts();
      }
    },
    [data]
  );
  useEffect(() => {
    if (!props.readOnly) {
      props.addOpen(editorId);
    }
    return () => {
      if (!props.readOnly) {
        props.removeOpen(editorId);
      }
    };
  }, []);

  useEffect(
    () => {
      if (editor && props.editorId === editorId) {
        editor.insertHtml(props.copiedContent);
      }
    },
    [props.copiedContent, props.copyClicked]
  );

  useEffect(
    () => {
      if (editor && props.width && props.height) {
        editor.resize(props.width, props.height);
      }
    },
    [props.width, props.height, editor]
  );
  // useEffect(
  //   () => {
  //     if (editor && props.width && props.height) {
  //       editor.resize(props.width, props.height);
  //     }
  //   },
  //   [props.width, props.height, editor]
  // );

  useEffect(
    () => {
      if (
        props.readOnly &&
        typeof props.initialContent !== "undefined" &&
        props.initialContent !== null
      ) {
        window.setTimeout(() => {
          //processAccessToken(props.initialContent);
          processAPILocation(props.initialContent, true);
          processDownloadLinks();
          processCharts();
          processReports();
          getPdfsForContent();
        });
      }
    },
    [props.readOnly, props.initialContent]
  );

  useEffect(() => {
    //list for events from data tables to refresh or sort
    window.addEventListener(
      "refreshDataEvent",
      (event) => {
        if (
          event.detail.chartid &&
          props.initialContent &&
          props.initialContent.includes(event.detail.chartid)
        ) {
          event.stopPropagation();
          processChart(event.detail.chartid);
        }
      },
      false
    );
    window.addEventListener(
      "sortDataEvent",
      (event) => {
        if (
          event.detail.id &&
          props.initialContent &&
          props.initialContent.includes(event.detail.id)
        ) {
          event.stopPropagation();
          sortChart(event.detail);
        }
      },
      false
    );
    window.addEventListener(
      "changeQueryParams",
      (event) => {
        if (
          event.detail.chartid &&
          props.initialContent &&
          props.initialContent.includes(event.detail.chartid)
        ) {
          event.stopPropagation();
          if (!queryParametersOpen) {
            setQueryParametersOpen(true);
            setChartToQuery(event.detail.chartid);
          }
        }
      },
      false
    );
  }, []);

    useEffect(() => {
    if(!pdfjsLib.GlobalWorkerOptions.workerPort) pdfjsLib.GlobalWorkerOptions.workerPort = new PdfjsWorker();
    let element = myElement.current;
    if (element) {
      var config = { childList: true, subtree: true, };
      var observer = new MutationObserver(function(mutations, observer) {
        props.onRenderComplete instanceof Function &&
            props.sectionId &&
            props.onRenderComplete(props.sectionId);
            observer.disconnect();
      });
      observer.observe(element, config);
    }
  }, []);

  const checkForAttachmentIds = () => {
    if (editor) {
      // pdf ids
      let containersPDF;
      if (!props.readOnly) {
        containersPDF = editor.document.$.getElementsByClassName(
          "pdf-container"
        );
      }
      let attachmentIds = [];
      for (let i = 0; i < containersPDF.length; i++) {
        let attachmentId = containersPDF[i].dataset.attachment;
        attachmentIds.push(attachmentId);
      }

      //download links
      let containersLink;
      if (!props.readOnly) {
        containersLink = editor.document.$.getElementsByClassName(
          "file-attachment"
        );
      }
      for (let i = 0; i < containersLink.length; i++) {
        if (
          containersLink[i].href &&
          containersLink[i].href.includes("/attachmentservice/attachment/")
        ) {
          let attachmentId = containersLink[i].dataset.attachment;
          attachmentIds.push(attachmentId);
        }
      }

      //image
      let containersImage;
      if (!props.readOnly) {
        containersImage = editor.document.$.querySelectorAll("img");
      }
      for (let i = 0; i < containersImage.length; i++) {
        if (
          containersImage[i].src &&
          containersImage[i].src.includes("/attachmentservice/attachment/")
        ) {
          let array = containersImage[i].src.split("/attachment/");
          let secondString = array[1];
          let array2 = secondString.split("/");
          let attachmentId = array2[0];
          attachmentIds.push(attachmentId);
        }
      }

      //videos
      let containersVideo;
      if (!props.readOnly) {
        containersVideo = editor.document.$.querySelectorAll("video");
      }
      for (let i = 0; i < containersVideo.length; i++) {
        if (
          containersVideo[i].src &&
          containersVideo[i].src.includes("/attachmentservice/attachment/")
        ) {
          let array = containersVideo[i].src.split("/attachment/");
          let secondString = array[1];
          let array2 = secondString.split("/");
          let attachmentId = array2[0];
          attachmentIds.push(attachmentId);
        }
      }

      if (props.updateUploadArray) {
        props.updateUploadArray(attachmentIds);
      }
    }
  };

  const processReports = () => {
    // force refresh all reports on initial load
    let allReports;
    if (props.readOnly) {
      let editorDiv = document.getElementById(`editor-${editorId}`);
      if (!editorDiv) return;
      allReports = editorDiv.getElementsByClassName("uks-chart");
    } else {
      allReports = editor.document.$.getElementsByClassName("uks-chart");
    }
    if (allReports.length > 0) {
      for (let i = 0; i < allReports.length; i++) {
        processChart(allReports[i].id);
      }
    }
  };

  const processCharts = () => {
    let allCharts;
    if (props.readOnly) {
      let editorDiv = document.getElementById(`editor-${editorId}`);
      if (!editorDiv) return;
      allCharts = editorDiv.getElementsByClassName("chart-uninitialized");
    } else {
      allCharts = editor.document.$.getElementsByClassName(
        "chart-uninitialized"
      );
    }
    if (allCharts.length > 0) {
      for (let i = 0; i < allCharts.length; i++) {
        processChart(allCharts[i].id);
      }
    }
  };

  const processDownloadLinks = () => {
    // register click listeners on download links to grab the blob
    let content = document.getElementById(`editor-${editorId}`);
    if (content) {
      let downloadLinks = content.getElementsByClassName(
        "file-attachment-download"
      );
      if (downloadLinks.length > 0) {
        for (let i = 0; i < downloadLinks.length; i++) {
          let link = downloadLinks[i];
          link.onclick = linkClickListener;
        }
      }
    }
  };

  const linkClickListener = function(e) {
    downloadLinkClick(e);
  };

  const processAccessToken = (data) => {
    // let accessToken = localStorage.getItem("access_token");
    // if (data.includes("%%KPS_ACCESS_TOKEN%%")) {
    //   data = data.replace(/%%KPS_ACCESS_TOKEN%%/g, accessToken);
    // }
    setData(data);
  };

  const getPdfsForContent = () => {
    let containers;
    if (props.readOnly) {
      containers = document.getElementsByClassName("pdf-container");
    } else {
      containers = editor.document.$.getElementsByClassName("pdf-container");
    }
    let attachmentIds = [];
    if (containers.length > 0) {
      for (let i = 0; i < containers.length; i++) {
        let attachmentId = containers[i].dataset.attachment;
        attachmentIds.push(attachmentId);
        getContentForAttachment(attachmentId, (evt) => {
          generatePdfViewer(attachmentId, evt.currentTarget.response);
        });
      }
    }
  };

  const getContentForAttachment = (attachmentId, callback) => {
    attachmentClient.get(`/attachment/${attachmentId}`).then((res) => {
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open(
        "GET",
        "https://" +
          apiLocation +
          "/attachmentservice/attachment/" +
          attachmentId +
          "/content/"
      );
      xhr.responseType = "blob";
      // xhr.setRequestHeader(
      //   "Authorization",
      //   "Bearer " + window.localStorage.getItem("access_token")
      // );
      xhr.addEventListener("load", (evt) => {
        if (callback) {
          callback(evt, res);
        }
      });
      xhr.send();
    });
  };

  const downloadLinkClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    getContentForAttachment(e.target.dataset.attachment, (evt, res) => {
      let link = document.createElement("a");
      link.href = URL.createObjectURL(evt.currentTarget.response);
      link.download = res.data.sourceFileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
      link.remove();
    });
  };

  const onChange = (event, hasChanged) => {
    let newData;
    if (!event.editor) {
      setData(event);
      newData = event;
    } else {
      newData = event.editor.getData();
      setData(event.editor.getData());
    }
    if (props.onChange && (!props.textSection || hasCustomFieldsChange || hasChanged)) {
      propsOnChange(newData);
      setHasCustomFieldsChange(false);
    }
  };
  const propsOnChange = (newData) => {
    // i really hate this but I can't think of a good way to strip out the access token
    // when saving data, but still keeping it in CKEditor so we can view the attachment
    // let escapedToken = escapeRegexString(localStorage.getItem("access_token"));
    // newData = newData.replace(
    //   new RegExp(escapedToken, "g"),
    //   "%%KPS_ACCESS_TOKEN%%"
    // );
    props.onChange(removeAPILocation(newData));
  };
  // const escapeRegexString = (string) => {
  //   return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
  // };

  const fileUpload = (event) => {
    event.stop();
    let xhr = event.data.fileLoader.xhr;
    xhr.withCredentials = true;
    // xhr.setRequestHeader(
    //   "Authorization",
    //   `Bearer ${localStorage.getItem("access_token")}`
    // );
    let formData = new FormData();
    formData.append(
      "file",
      event.data.fileLoader.file,
      event.data.fileLoader.fileName
    );

    xhr.send(formData);
  };

  const fileUploadResponse = (event) => {
    event.stop();
    let response = JSON.parse(event.data.fileLoader.xhr.responseText);
    event.data.url = `https://${apiLocation}/attachmentservice/attachment/${
      response.id
    }/content/`;
    event.data.fileName = response.sourceFileName;
    setTimeout(() => event.editor.fire("change"));
  };

  const commandExec = (e) => {
    switch (e.data.name) {
      case "graphEdit":
        let editSelection = e.editor.getSelection().getStartElement();
        if (
          !editSelection.hasClass("cke_widget_wrapper") ||
          !editSelection.getChild(0).hasClass("uks-chart")
        ) {
          break;
        }
        e.editor.getSelection().selectElement(editSelection);
        setReportEdit(editSelection.getChild(0));
        break;
      case "graph":
        setReportDialogOpen(true);
        break;
      case "graphDelete":
        let selection = e.editor.getSelection().getStartElement();
        if (
          !selection.hasClass("cke_widget_wrapper") ||
          !selection.getChild(0).hasClass("uks-chart")
        ) {
          break;
        }
        selection.remove();
        break;
      case "documentLinkEdit":
        let linkElement = e.editor.getSelection().getStartElement();
        if (!linkElement.hasClass("document-link")) {
          // if we are trying to edit a doc link but we don't know
          // which one to edit then give up
          break;
        }
        e.editor.getSelection().selectElement(linkElement);
        setDocumentLinkEdit(linkElement);
        setDocumentDialogOpen(true);
      case "customFieldsEdit":
        let customField = e.editor.getSelection().getStartElement();
        if (!customField.hasClass("custom-field")) {
          break;
        }
        e.editor.getSelection().selectElement(customField);
        openCustomFieldsEdit(customField);
        break;
      case "documentLink":
        setDocumentDialogOpen(true);
        break;
      case "customFields":
        setCustomFieldsDialogOpen(true);
        break;
      case "attachFile":
        setAttachFileOpen(true);
        break;
      case "globalAttachments":
        setGlobalAttachmentsOpen(true);
        break;
      default:
        break;
    }
  };
  const openCustomFieldsEdit = (element) => {
    // const result = props.currentCustomFields.filter(
    //   (cf) => cf.tempId == element.$.dataset.id
    // );
   // setCustomFieldSelected(result[0]);
    setCustomFieldSelected(element.$.dataset.id);
    setCustomFieldsEdit(true);
  };

  const insertDocumentLink = (title, document, newTab) => {
    setDocumentDialogOpen(false);
    setDocumentLinkEdit(null);
    editor.insertHtml(
      `<a href="/full/document/${document}" class="document-link" target="${
        newTab ? "_blank" : "_self"
      }">${title}</a>`
    );
  };

  const insertCustomFieldsLink = (customFields, type) => {
    setCustomFieldsDialogOpen(false);
    let elements = "";
    customFields.map((customField) => {
      let text = "";
      let value = "";
      if (customField.fieldType === "date") {
        value = moment(customField.value).format("DD/MM/YYYY");
      } else if (customField.fieldType === "multiselect") {
        let array;
        try {
          array = JSON.parse(customField.value);
        } catch {
          array = [];
        }
        array.map((item, idx) => {
          value = value + item;
          if (idx + 1 != array.length) {
            value = value + ", ";
          }
        });
      } else {
        value = customField.value;
      }

      if (type === "Label") {
        text = customField.name;
      } else if (type === "Value") {
        text = value;
      } else {
        text = `${customField.name}:${value}`;
      }
      let id = "customfield-" + customField.tempId;
      // editor.insertHtml(
      //   `<span class="custom-field ${type}" style="color:blue;text-align:center" data-id=${customField.tempId} name=${id}>${text}</span>&nbsp;`
      // );
      elements =
        elements +
        `<span class="custom-field ${type}" style="color:blue;text-align:center" data-id=${
          customField.tempId
        } name=${id}>${text}</span>&nbsp;`;
    });
    editor.insertHtml(elements);
  };

  const insertChart = (chart) => {
    setReportDialogOpen(false);
    if (chart.chart.chartType === "Table") {
      return insertTable(chart);
    }
    let id = `chart-${shortid.generate()}`;
    editor.insertHtml(
      `<canvas class="uks-chart chart-uninitialized" id=${id} width=${
        chart.chart.width
      } height=${chart.chart.height} data-chart=${window.btoa(
        JSON.stringify(chart)
      )}></canvas><br />`
    );
    processChart(id);
  };

  const insertTable = (chartObject) => {
    let id = `chart-${shortid.generate()}`;
    chartObject.chartElementId = id;
    chartObject.chart.data = []; //don't store data in the Dom object
    // let groupBy = chartObject.chart.groupByKey;
    // let includeSummary = chartObject.chart.includeSummary;
    let customEv = `refreshDataEvent`;
    let changeParams = `changeQueryParams`;

    try {
      //insert a placeholder for a Table Of Contents for grouped data

      // groupBy === "none" ? `
      //   <div class="uks-report">
      //     <div>
      //       <table class="mat-summary-table">
      // <thead>
      //   <th colspan="2">
      //     <button class="refresh-button"
      //       onClick="(function(e){
      //         window.parent.dispatchEvent(new CustomEvent('${changeParams}', { detail: { chartid : '${id}'}}));
      //         return false;
      //       })();return false;"
      //     >
      //       <svg id="refresh-icon" class="refresh-icon" viewBox="0 0 24 24">
      //         <path d="${filterSvg}" fill="black"/>
      //       </svg>
      //     </button>
      //     <button class="refresh-button"
      //       onClick="(function(e){
      //         window.parent.dispatchEvent(new CustomEvent('${customEv}', { detail: { chartid : '${id}'}}));
      //         return false;
      //       })();return false;"
      //     >
      //       <svg id="refresh-icon" class="refresh-icon" viewBox="0 0 24 24">
      //         <path d="${refreshSvg}" fill="black"/>
      //       </svg>
      //     </button>
      //   </th>
      // </thead>
      //         <tbody id="query-dtls-${id}">
      //         </tbody>
      //       </table>
      //     </div>
      //     <div id="group-summary-chart-${id}" class="summary-chart-wrapper">
      //     </div>
      //     <div id=${id} class="uks-chart" data-chart=${window.btoa(
      //       JSON.stringify(chartObject)
      //     )}>
      //     </div>
      //   </div>
      //   <br />`
      //   :
      let html = `
        <div class="uks-report">
          <div style="display:flex">
            <div id="toc-${id}">
            </div>
            <div style="width:100%">
              <div>
                <table class="mat-summary-table">
                  <thead>
                    <th colspan="2">
                      <button class="refresh-button filter-button"
                        onClick="(function(e){
                          window.dispatchEvent(new CustomEvent('${changeParams}', { detail: { chartid : '${id}'}}));
                          return false;
                        })();return false;"
                      >
                        <svg id="refresh-icon" class="refresh-icon" viewBox="0 0 24 24">
                          <path d="${filterSvg}" fill="black"/>
                        </svg>
                      </button>                
                      <button class="refresh-button"
                        onClick="(function(e){
                          window.dispatchEvent(new CustomEvent('${customEv}', { detail: { chartid : '${id}'}}));
                          return false;
                        })();return false;"
                      >
                        <svg id="refresh-icon" class="refresh-icon" viewBox="0 0 24 24">
                          <path d="${refreshSvg}" fill="black"/>
                        </svg>
                      </button>
                    </th>
                  </thead>
                  <tbody id="query-dtls-${id}">
                  </tbody>
                </table>
              </div>            
              <div>
                <div class="summary-wrapper">
                  <div id="group-summary-${id}">
                  </div>
                  <div id="group-summary-chart-${id}" class="summary-chart-wrapper">
                  </div>   
                </div>       
                <div id=${id} class="uks-chart" data-chart=${window.btoa(
        JSON.stringify(chartObject)
      )}>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />`;
      editor.insertHtml(html);
    } catch (x) {
      alert(x);
    }
  };

  const getRowsData = (items, usedKeys) => {
    let str = "";
    items.map((row, index) => {
      str += `<tr key=${index} class="mat-row">
          ${renderRow({ key: index, data: row, usedKeys: usedKeys })}
        </tr>`;
    });
    return str;
  };
  const renderFooterRow = (
    data,
    usedKeys,
    numericColumnsOnly,
    numericColumns
  ) => {
    let str = "";
    if (usedKeys.some((key) => numericColumns.includes(key))) {
      let nonNumericFirstCol = !numericColumns.includes(usedKeys[0]);
      if (nonNumericFirstCol || numericColumnsOnly) {
        str = `<th class='mat-footer-cell' scope='row'>${t(
          "report_totals"
        )}</th>`;
      }

      usedKeys.map((key, index) => {
        let keyStr =
          !key.toLowerCase().endsWith("id") && numericColumns.includes(key)
            ? `<td class="mat-footer-cell">${data
                .map((el) => el[key])
                .reduce((a, b) => a + b, 0)}</td>`
            : numericColumnsOnly
              ? ``
              : `<td class="mat-footer-cell"></td>`;

        str += nonNumericFirstCol && index === 0 ? "" : keyStr;
      });
    }

    return str;
  };

  const getHeader = (chartObject, group) => {
    let chart = chartObject.chart;
    var keys = chart.usedKeys;
    if (Array.isArray(keys)) {
      let str = "";
      let customEv = `sortDataEvent`;
      let id = chartObject.chartElementId;
      let query;
      let params = {};
      try {
        query = JSON.parse(chart.query);
        params = query.variables;
      } catch (x) {}

      keys.map((key, index) => {
        const sortProp = params.hasOwnProperty("userSort")
          ? "userSort"
          : params.hasOwnProperty("documentSort")
            ? "documentSort"
            : "topicSort";
        let sortIconActive = key === params[sortProp].sortColumn;
        let isAsc = sortIconActive && params[sortProp].sortDirection === "asc";
        let sortIcon = isAsc ? sortAscSvg : sortDescSvg;
        let fill = sortIconActive ? "black" : "lightgrey";
        let targetDirection = sortIconActive
          ? isAsc
            ? "desc"
            : "asc"
          : "desc"; //when clicked what direction to sort in
        str += `<th class="mat-header-cell" id="${group}-${key}" 
            onClick="(function(e){
              window.dispatchEvent(new CustomEvent('${customEv}', { detail: { id: '${id}', params: '${key}', targetdirection: '${targetDirection}' }}));          
              return false;
            })();return false;"
          >
            <div style="display:flex">
              <div>${t("report_column_" + key).toUpperCase()}</div>
              <div>
                <svg class="sort-icon" viewBox="0 0 24 24">
                  <path d="${sortIcon}" fill="${fill}"/>
                </svg>
              </div>
            </div>
          </th>`;
      });
      return str;
    }
  };

  const renderRow = (props) => {
    let str = "";
    props.usedKeys.map((key, index) => {
      let renderData;
      props.data[key] instanceof Object
        ? (renderData = JSON.stringify(props.data[key]))
        : (renderData = props.data[key]);
      str +=
        props.data.hasOwnProperty("documentId") &&
        props.data.hasOwnProperty("title") &&
        key === "title"
          ? `<td class="mat-cell">
          <a href="/full/document/${
            props.data["documentId"]
          }" class="document-link" target="_self">${props.data[key]}</a></td>`
          : `<td class="mat-cell">${renderData}</td>`;
    });
    return str;
  };
  const getGroupLinks = (groupBy, groups) => {
    let groupLinks = "";
    groups.forEach((group) => {
      groupLinks += `
      <tr><td class="mat-cell"><a class="tocLink" href="javascript:void(0)" onclick="document.getElementById('${group}').scrollIntoView();">${group}</a></td></tr>
      `;
    });
    return groupLinks;
  };
  const getSummableColumns = (resultData, keys) => {
    if (!resultData) return [];
    return keys
      .filter((key) => {
        return !resultData.map((ele) => ele[key]).some(isNaN);
      })
      .filter((key) => !key.toLowerCase().endsWith("id"));
  };
  const getGroupSummary = (
    groupBy,
    groups,
    resultData,
    chartObject,
    numericColumns
  ) => {
    let groupLinks = "";
    groups.forEach((group) => {
      let groupData = resultData.filter((el) => {
        return el[groupBy] === group;
      });
      let groupRowDetails = "";
      numericColumns.forEach((col) => {
        if (!col.toLowerCase().endsWith("id")) {
          let colData = groupData
            .map((el) => el[col])
            .reduce((a, b) => a + b, 0);
          groupRowDetails += `<td class="mat-cell">${colData}</td>`;
        }
      });
      groupLinks += `
      <tr>
        <td class="mat-cell">
          <a class="tocLink" href="javascript:void(0)" onclick="document.getElementById('${group}').scrollIntoView();">${group}</a>
        </td>
        ${groupRowDetails}
      </tr>
      `;
    });
    return groupLinks;
  };
  const getQueryDates = (query) => {
    let startDate;
    let endDate;

    if (query.variables.hasOwnProperty("dateRange")) {
      let units = query.variables.dateRange.units;
      let qualifier = query.variables.dateRange.qualifier;
      startDate = query.variables.dateRange.startDate
        ? query.variables.dateRange.startDate
        : new Date(
            moment()
              .subtract(qualifier === "current" ? 0 : 1, units)
              .startOf(units)
          ).getTime();
      endDate = query.variables.dateRange.endDate
        ? query.variables.dateRange.endDate
        : qualifier === "current"
          ? new Date().getTime()
          : new Date(
              moment()
                .subtract(1, units)
                .endOf(units)
            ).getTime();
    }
    // let periodDesc = ''

    return (
      moment(startDate).format("LLLL") + " - " + moment(endDate).format("LLLL")
    );
  };
  const processTableError = (chartObject) => {
    let chartElement;
    if (props.readOnly) {
      chartElement = document.getElementById(chartObject.chartElementId);
    } else {
      if (!editor.document) return;
      chartElement = editor.document.findOne(`#${chartObject.chartElementId}`);
    }
    if (!chartElement) {
      return;
    }
    if (props.readOnly) {
      while (chartElement.hasChildNodes()) {
        chartElement.removeChild(chartElement.lastChild);
      }
      chartElement.insertAdjacentHTML(
        "beforeend",
        `<p style="text-align: center;">${t("report_error_occurred")}</p>`
      );
    } else {
      let child;
      while ((child = chartElement.getChild(0)) !== null) {
        child.remove();
      }
      chartElement.appendHtml(
        "beforeend",
        `<p style="text-align: center;">${t("report_error_occurred")}</p>`
      );
    }
  };

  const processTableData = (resultData, chartObject) => {
    let chartElement;
    let tocElement;
    let summaryElement;
    let summaryChartElement;
    let queryDetailsElement;
    let query = JSON.parse(chartObject.chart.query);
    let lastProcessed = new Date();
    let summaryChart = {};
    summaryChart.width = 400;
    summaryChart.height = 400;

    if (props.readOnly) {
      chartElement = document.getElementById(chartObject.chartElementId);
      tocElement = document.getElementById("toc-" + chartObject.chartElementId);
      summaryElement = document.getElementById(
        "group-summary-" + chartObject.chartElementId
      );
      summaryChartElement = document.getElementById(
        "group-summary-chart-" + chartObject.chartElementId
      );
      queryDetailsElement = document.getElementById(
        "query-dtls-" + chartObject.chartElementId
      );
    } else {
      if (!editor.document) return;
      chartElement = editor.document.findOne(`#${chartObject.chartElementId}`);
      tocElement = editor.document.findOne(
        `#toc-${chartObject.chartElementId}`
      );
      summaryElement = editor.document.findOne(
        `#group-summary-${chartObject.chartElementId}`
      );
      summaryChartElement = editor.document.findOne(
        "#group-summary-chart-" + chartObject.chartElementId
      );
      queryDetailsElement = editor.document.findOne(
        "#query-dtls-" + chartObject.chartElementId
      );
    }
    if (!chartElement) {
      return;
    }
    //get a list of numeric colummns that can be summarized and add them to the chartElement for reuse
    chartObject.chart.numericColumns = getSummableColumns(
      resultData,
      chartObject.chart.keys
    );
    chartElement.setAttribute(
      "data-chart",
      window.btoa(JSON.stringify(chartObject))
    );

    //build the html for the table showing the query parameters

    let queryDtlsHtml = `
      <tbody>
        <tr>
          <td class="mat-header-cell">${t(
            "report_date_range"
          ).toUpperCase()}</td>
          <td class="mat-cell" id="query-date-range">${getQueryDates(
            query
          )}</td>
        </tr>
        <tr>
          <td class="mat-header-cell">${t(
            "report_prepared_by"
          ).toUpperCase()}</td>
          <td class="mat-cell">${props.currentUser.firstName +
            " " +
            props.currentUser.surname +
            " (" +
            props.currentUser.userLogin +
            ")"}</td>
        </tr>
        <tr>
          <td class="mat-header-cell">${t(
            "report_last_updated"
          ).toUpperCase()}</td>
          <td class="mat-cell">${moment(lastProcessed).format("LLLL")}</td>
        </tr>
      </tbody>
    `;

    //find groups and create a table for each...
    let groupBy = chartObject.chart.groupByKey;
    let groups = resultData
      ? resultData.map((obj) => obj[groupBy]).filter((value, index, self) => {
          return self.indexOf(value) === index;
        })
      : [];

    let summaryChartHtml = `
      <canvas id="summary-chart-canvas${chartObject.chartElementId}" height=${
      summaryChart.height
    } width=${summaryChart.width}>
      </canvas>
    `;

    //build the html for a table of contents if grouped
    let tocHtml = "";
    let sortEv = `sortDataEvent`;
    const sortProp = query.variables.hasOwnProperty("userSort")
      ? "userSort"
      : query.variables.hasOwnProperty("documentSort")
        ? "documentSort"
        : "topicSort";
    let groupSortIconActive = groupBy === query.variables[sortProp].sortColumn;
    let isGroupAsc =
      groupSortIconActive && query.variables[sortProp].sortDirection === "asc";
    let groupSortIcon = isGroupAsc ? sortAscSvg : sortDescSvg;
    let groupFill = groupSortIconActive ? "black" : "lightgrey";
    let groupDirection = groupSortIconActive
      ? isGroupAsc
        ? "desc"
        : "asc"
      : "desc"; //when clicked what direction to sort in
    tocHtml +=
      groups.length > 1
        ? `
        <div class="toc-wrapper">
          <h3><u>${t("report_toc_header")}</u></h3>
          <table class="mat-table">
          <thead>
            <th class="mat-header-cell"
              onClick="(function(e){
                window.dispatchEvent(
                  new CustomEvent('${sortEv}', 
                    { detail: 
                      { id: '${chartObject.chartElementId}', 
                        params: '${groupBy}',
                        targetdirection: '${groupDirection}' 
                      }
                    } 
                  )
                );          
                return false;
              })();return false;"
            >
              <div style="display:flex">
                <div>${t("report_column_" + groupBy).toUpperCase()}</div>
                <div>
                  <svg class="sort-icon" viewBox="0 0 24 24">
                    <path d="${groupSortIcon}" fill="${groupFill}"/>
                  </svg>
                </div>
              </div>              
            </th>
          </thead>
          <tbody>${getGroupLinks(groupBy, groups)}</tbody>
          </table>
        </div>
        `
        : ``;
    // tocHtml += groups.length > 1
    // ?
    //   `
    //   <div class="toc-wrapper">
    //     <h3><u>${props.t("report_toc_header")}</u></h3>
    //     <span>${props.t("report_column_" + groupBy).toUpperCase()}</span>
    //     <ul>${getGroupLinks(groupBy,groups)}</ul>
    //   </div>
    //   `
    // : ``

    let tableHtml = "";
    groups.length > 1
      ? groups.forEach((group) => {
          let groupData = resultData.filter((el) => {
            return el[groupBy] === group;
          });
          tableHtml += `
          <h3 id='${group}'>${t(
            "report_column_" + groupBy
          ).toUpperCase()} : <b>${group}</b></h3>
          <table class="mat-table">
          <thead>
            <tr class="mat-header-row">${getHeader(chartObject, group)}</tr>
          </thead>
          <tbody>${getRowsData(groupData, chartObject.chart.usedKeys)}</tbody>
          <tfoot>${renderFooterRow(
            groupData,
            chartObject.chart.usedKeys,
            false,
            chartObject.chart.numericColumns
          )}</tfoot>
          </table><br/><br/>`;
        })
      : (tableHtml += `
          <table class="mat-table">
          <thead>
            <tr class="mat-header-row">${getHeader(chartObject, "all")}</tr>
          </thead>
          <tbody>${getRowsData(resultData, chartObject.chart.usedKeys)}</tbody>
          <tfoot>${renderFooterRow(
            resultData,
            chartObject.chart.usedKeys,
            false,
            chartObject.chart.numericColumns
          )}</tfoot>
          </table><br/><br/>`);

    if (props.readOnly) {
      while (chartElement.hasChildNodes()) {
        chartElement.removeChild(chartElement.lastChild);
      }
      chartElement.insertAdjacentHTML("afterbegin", tableHtml);
      chartElement.classList.remove("chart-uninitialized");
      if (tocElement) {
        if (
          groups.length > 1 &&
          !tocElement.classList.contains("toc-sidebar")
        ) {
          tocElement.classList.add("toc-sidebar");
        } else if (
          groups.length <= 1 &&
          tocElement.classList.contains("toc-sidebar")
        ) {
          tocElement.classList.remove("toc-sidebar");
        }
        while (tocElement.hasChildNodes()) {
          tocElement.removeChild(tocElement.lastChild);
        }
        tocElement.insertAdjacentHTML("afterbegin", tocHtml);
      }
      if (summaryElement) {
        while (summaryElement.hasChildNodes()) {
          summaryElement.removeChild(summaryElement.lastChild);
        }
        chartObject.chart.includeSummary &&
          summaryElement.insertAdjacentHTML(
            "afterbegin",
            getSummaryHtml(
              chartObject.chart.numericColumns,
              resultData,
              chartObject,
              groups,
              groupBy
            )
          );
      }
      if (summaryChartElement) {
        while (summaryChartElement.hasChildNodes()) {
          summaryChartElement.removeChild(summaryChartElement.lastChild);
        }
        if (chartObject.chart.includeSummaryChart) {
          summaryChartElement.insertAdjacentHTML(
            "afterbegin",
            summaryChartHtml
          );
          createSummaryChart(
            summaryChartElement.firstElementChild,
            chartObject.chart.numericColumns,
            resultData,
            groups,
            groupBy
          );
        }
      }
      if (queryDetailsElement) {
        while (queryDetailsElement.hasChildNodes()) {
          queryDetailsElement.removeChild(queryDetailsElement.lastChild);
        }
        queryDetailsElement.insertAdjacentHTML("afterbegin", queryDtlsHtml);
      }
    } else {
      let child;
      while ((child = chartElement.getChild(0)) !== null) {
        child.remove();
      }
      chartElement.appendHtml(tableHtml);
      chartElement.removeClass("chart-uninitialized");
      if (tocElement) {
        if (groups.length > 1 && !tocElement.hasClass("toc-sidebar")) {
          tocElement.addClass("toc-sidebar");
        } else if (groups.length <= 1 && !tocElement.hasClass("toc-sidebar")) {
          tocElement.removeClass("toc-sidebar");
        }
        let tocChild;
        while ((tocChild = tocElement.getChild(0)) !== null) {
          tocChild.remove();
        }
        tocElement.appendHtml(tocHtml);
      }
      if (summaryElement) {
        let summaryChild;
        while ((summaryChild = summaryElement.getChild(0)) !== null) {
          summaryChild.remove();
        }
        chartObject.chart.includeSummary &&
          summaryElement.appendHtml(
            getSummaryHtml(
              chartObject.chart.numericColumns,
              resultData,
              chartObject,
              groups,
              groupBy
            )
          );
      }
      if (summaryChartElement) {
        let summaryChartChild;
        while ((summaryChartChild = summaryChartElement.getChild(0)) !== null) {
          summaryChartChild.remove();
        }
        if (chartObject.chart.includeSummaryChart) {
          summaryChartElement.appendHtml(summaryChartHtml);
          createSummaryChart(
            summaryChartElement.$.firstElementChild,
            chartObject.chart.numericColumns,
            resultData,
            groups,
            groupBy
          );
        }
      }
      if (queryDetailsElement) {
        let queryDetailsElementChild;
        while (
          (queryDetailsElementChild = queryDetailsElement.getChild(0)) !== null
        ) {
          queryDetailsElementChild.remove();
        }
        queryDetailsElement.appendHtml(queryDtlsHtml);
      }
    }
  };
  const createSummaryChart = (
    summaryChartElement,
    numericColumns,
    chartData,
    groups,
    groupBy
  ) => {
    // let datasets = [];
    // let labelArray = [];
    // numericColumns.filter(el => !el.toLowerCase().endsWith("id")).forEach((col) => {
    //   let dataArray = [];
    //   groups.forEach((group) => {
    //     let groupData = chartData.filter((el) => {
    //       return el[groupBy] === group
    //     })
    //     dataArray.push(groupData.map(data => data[col]).reduce((a, b) => a + b, 0));
    //     !labelArray.includes(group) && labelArray.push(group);
    //   })
    //   datasets.push(
    //     {
    //       label: props.t("report_column_" + col),
    //       data: dataArray,
    //     }
    //   )

    // })

    let pieLabelArray = [];
    let pieDataArray = [];
    numericColumns
      .filter((el) => !el.toLowerCase().endsWith("id"))
      .forEach((col) => {
        pieDataArray.push(
          chartData.map((el) => el[col]).reduce((a, b) => a + b, 0)
        );
        pieLabelArray.push(t("report_column_" + col));
      });
    let pieDataSets = [];
    pieDataSets.push({
      label: t("report_totals"),
      data: pieDataArray,
    });

    // let types = {
    //   BarChart: "bar",
    //   LineChart: "line",
    //   PieChart: "pie",
    // };

    let data = {
      labels: pieLabelArray,
      datasets: pieDataSets,
    };

    let legend = {
      display: true,
      position: "bottom",
      align: "center",
    };

    let scales = {
      // xAxes: [
      //   {
      //     scaleLabel: {
      //       display: false,
      //       labelString: ''
      //     },
      //   },
      // ],
      // yAxes: [
      //   {
      //     scaleLabel: {
      //       display: true,
      //       labelString: props.t("report_column_" + groupBy),
      //     },
      //     stacked: true
      //   },
      // ],
    };

    new Chart(summaryChartElement, {
      type: "pie",
      data,
      options: {
        maintainAspectRatio: false,
        responsive: false,
        legend,
        scales,
        plugins: {
          colorschemes: {
            scheme: "tableau.Tableau20",
          },
        },
      },
    });
  };
  const getSummaryHtml = (
    numericColumns,
    resultData,
    chartObject,
    groups,
    groupBy
  ) => {
    let numericHeaders = "";

    let customEv = `sortDataEvent`;
    let query;
    let params = {};
    try {
      query = JSON.parse(chartObject.chart.query);
      params = query.variables;
    } catch (x) {}
    const sortProp = params.hasOwnProperty("userSort")
      ? "userSort"
      : params.hasOwnProperty("documentSort")
        ? "documentSort"
        : "topicSort";

    numericColumns
      .filter((el) => !el.toLowerCase().endsWith("id"))
      .forEach((col) => {
        let sortIconActive = col === params[sortProp].sortColumn;
        let isAsc = sortIconActive && params[sortProp].sortDirection === "asc";
        let sortIcon = isAsc ? sortAscSvg : sortDescSvg;
        let fill = sortIconActive ? "black" : "lightgrey";
        let targetDirection = sortIconActive
          ? isAsc
            ? "desc"
            : "asc"
          : "desc"; //when clicked what direction to sort in
        numericHeaders += `
        <th class="mat-header-cell" 
          onClick="(function(e){
            window.dispatchEvent(new CustomEvent('${customEv}', { detail: { id: '${
          chartObject.chartElementId
        }',editorId: '${editorId}', params: '${col}', targetdirection: '${targetDirection}' }}));          
            return false;
          })();return false;"
        >
          <div style="display:flex">
            <div>${t("report_column_" + col).toUpperCase()}</div>
            <div>
              <svg class="sort-icon" viewBox="0 0 24 24">
                <path d="${sortIcon}" fill="${fill}"/>
              </svg>
            </div>
          </div>          
        </th>`;
      });

    let summaryHtml = "";
    let groupSortIconActive = groupBy === params[sortProp].sortColumn;
    let isGroupAsc =
      groupSortIconActive && params[sortProp].sortDirection === "asc";
    let groupSortIcon = isGroupAsc ? sortAscSvg : sortDescSvg;
    let groupFill = groupSortIconActive ? "black" : "lightgrey";
    let groupDirection = groupSortIconActive
      ? isGroupAsc
        ? "desc"
        : "asc"
      : "desc"; //when clicked what direction to sort in
    summaryHtml +=
      groups.length > 1
        ? `
        <div class="sum-table-wrapper">
          <h2>${t("report_summary_title")}</h2>
          <table class="mat-summary-table">
            <thead>
              <th class="mat-header-cell"
                onClick="(function(e){
                  window.dispatchEvent(
                    new CustomEvent('${customEv}', 
                      { detail: 
                        { id: '${chartObject.chartElementId}',
                          params: '${groupBy}', 
                          targetdirection: '${groupDirection}' 
                        }
                      } 
                    )
                  );          
                  return false;
                })();return false;"
              >
                ${t("report_column_" + groupBy).toUpperCase()}
                <svg class="sort-icon" viewBox="0 0 24 24">
                  <path d="${groupSortIcon}" fill="${groupFill}"/>
                </svg>
              </th>
              ${numericHeaders}
            </thead>
            <tbody>${getGroupSummary(
              groupBy,
              groups,
              resultData,
              chartObject,
              numericColumns
            )}</tbody>
            <tfoot>${renderFooterRow(
              resultData,
              numericColumns,
              true,
              numericColumns
            )}</tfoot>
          </table>
        </div>
        `
        : ``;
    return summaryHtml;
  };
  const processTable = (chartId) => {
    let chartElement;
    let chartData;

    if (props.readOnly) {
      chartElement = document.getElementById(chartId);
    } else {
      if (!editor.document) return;
      chartElement = editor.document.findOne(`#${chartId}`);
    }
    if (!chartElement) {
      return;
    }

    if (props.readOnly) {
      chartData = chartElement.dataset.chart;
    } else {
      chartData = chartElement.getAttribute("data-chart");
    }

    let chartObject = JSON.parse(window.atob(chartData));
    chartObject.chartElementId = chartId;
    if (chartObject.chart.chartType !== "Table") {
      return;
    }
    getChartData(
      chartObject,
      (resultData) => processTableData(resultData, chartObject),
      (e) => processTableError({ ...chartObject, error: e.toString() })
    );
  };

  const sortChart = (details) => {
    let chartId = details.id;
    let sortKey = details.params;
    let targetDirection = details.targetdirection;
    let chartElement;
    // if (props.readOnly) {
    chartElement = document.getElementById(chartId);
    // } else {
    //   chartElement = editor.document.$.getElementById(chartId);
    // }

    if (!chartElement || !chartElement.dataset.chart) {
      return;
    }
    let chartObject = JSON.parse(window.atob(chartElement.dataset.chart));
    let query = JSON.parse(chartObject.chart.query);
    let vars = query.variables;
    const sortProp = vars.hasOwnProperty("userSort")
      ? "userSort"
      : vars.hasOwnProperty("documentSort")
        ? "documentSort"
        : "topicSort";

    if (
      !(
        vars[sortProp].sortColumn === sortKey &&
        vars[sortProp].sortDirection === targetDirection
      )
    ) {
      //the triggering window event is called for every frame in the document
      //only sort if another event hasn't got there first
      if (vars[sortProp].sortColumn === sortKey) {
        if (vars[sortProp].sortDirection === "asc") {
          vars[sortProp].sortDirection = "desc";
        } else {
          vars[sortProp].sortDirection = "asc";
        }
      } else {
        vars[sortProp].sortColumn = sortKey;
        vars[sortProp].sortDirection = "desc";
      }
      query.variables = vars;
      chartObject.chart.query = JSON.stringify(query);
      chartElement.setAttribute(
        "data-chart",
        window.btoa(JSON.stringify(chartObject))
      );

      getChartData(
        chartObject,
        (resultData) => processTableData(resultData, chartObject),
        (e) => processTableError({ ...chartObject, error: e.toString() })
      );
    }
  };

  const processChart = (chartId) => {
    let chartElement;

    if (props.readOnly || editor === null) {
      chartElement = document.getElementById(chartId);
    } else {
      chartElement = editor.document.$.getElementById(chartId);
    }

    if (!chartElement || !chartElement.dataset.chart) {
      return;
    }
    let chartObject = JSON.parse(window.atob(chartElement.dataset.chart));
    if (chartObject.chart.chartType === "Table") {
      return processTable(chartId);
    }

    getChartData(
      chartObject,
      (chartData) => {
        let chart = chartObject.chart;
        let types = {
          BarChart: "bar",
          LineChart: "line",
          PieChart: "pie",
        };

        let dataArray = [];
        let labelArray = [];
        chartData.forEach((item) => {
          dataArray.push(item[chart.series.y]);
          labelArray.push(item[chart.series.x]);
        });

        let data = {
          labels: labelArray,
          datasets: [
            {
              label: chart.legendLabel,
              backgroundColor:
                chart.series.chartType === "PieChart"
                  ? getColours(labelArray.length, chart.patterns)
                  : `rgba(${chart.color.r},${chart.color.g},${chart.color.b},${
                      chart.color.a
                    })`,
              data: dataArray,
            },
          ],
        };

        let legend = {
          display: chart.legend ? true : false,
          position: chart.legendPosition,
          align: chart.legendAlign,
        };

        let scales =
          chart.series.chartType === "PieChart"
            ? {}
            : {
                xAxes: [
                  {
                    scaleLabel: {
                      display: !!chart.xAxisTitle,
                      labelString: chart.xAxisTitle,
                    },
                  },
                ],
                yAxes: [
                  {
                    scaleLabel: {
                      display: !!chart.yAxisTitle,
                      labelString: chart.yAxisTitle,
                    },
                  },
                ],
              };

        new Chart(chartElement, {
          type: types[chart.series.chartType],
          data,
          options: {
            maintainAspectRatio: false,
            responsive: false,
            legend,
            scales,
          },
        });
        chartElement.classList.remove("chart-uninitialized");
      },
      (e) => processTableError({ ...chartObject, error: e.toString() })
    );
  };

  const processAPILocation = (data, shouldSetData) => {
    if (data.includes("%%KPS_API_LOCATION%%")) {
      data = data.replaceAll("/%%KPS_API_LOCATION%%/", apiLocation);
    }
    shouldSetData && setData(data);
    return data;
  };

  const removeAPILocation = (data) => {
    if (data.includes(apiLocation)) {
      data = data.replaceAll(apiLocation, /%%KPS_API_LOCATION%%/);
    }
    //setData(data);
    return data;
  };

  const editChart = (newChart) => {
    reportEdit.setAttribute(
      "data-chart",
      window.btoa(JSON.stringify(newChart))
    );
    processChart(reportEdit.getId());
    setReportDialogOpen(false);
    setReportEdit(null);
    editor.fire("change", null, editor);
  };

  const editCustomField = (row) => {
    let array = [...props.currentCustomFields];
    if (row.tempId || row.tempId === 0) {
      array.forEach((cf,idx)=>{
        if(cf.tempId==row.tempId){
          array[idx]=row;
        }
      });
    }
    props.setCustomFields(array);
    setCustomFieldSelected(null);
    setCustomFieldsEdit(false);
  };

  const editDocumentLink = (title, document, newTab) => {
    documentLinkEdit.setText(title);
    documentLinkEdit.setAttribute("href", `/full/document/${document}`);
    documentLinkEdit.setAttribute("target", newTab ? "_blank" : "_self");
    documentLinkEdit.removeAttribute('data-cke-saved-href');
    // the element is edited in place but we need to reselect it after editing
    let range = editor.createRange();
    range.setStartBefore(documentLinkEdit);
    range.setEndAfter(documentLinkEdit);
    editor.getSelection().selectRanges([range]);
    setDocumentDialogOpen(false);
    setDocumentLinkEdit(null);
    editor.fire( 'change' ); 
  };

  const getQueryParams = () => {
    let chartElement = document.getElementById(chartToQuery);
    if (chartElement) {
      let chartObject = JSON.parse(window.atob(chartElement.dataset.chart));
      if (chartObject) {
        return chartObject;
      } else {
        return {};
      }
    }
  };
  const setQueryParams = (params) => {
    let chartElement = document.getElementById(chartToQuery);
    if (chartElement) {
      let chartObject = JSON.parse(window.atob(chartElement.dataset.chart));
      try {
        let query = JSON.parse(chartObject.chart.query);
        query.variables = params.variables;
        chartObject.chart.usedKeys = params.usedKeys;
        chartObject.chart.includeSummary = params.includeSummary;
        chartObject.chart.includeSummaryChart = params.includeSummaryChart;
        chartObject.chart.toc = params.includeToc;
        chartObject.chart.groupByKey = params.groupByKey;
        chartObject.chart.query = JSON.stringify(query);
        chartElement.setAttribute(
          "data-chart",
          window.btoa(JSON.stringify(chartObject))
        );
        processChart(chartToQuery);
      } catch (x) {}
    }
    setQueryParametersOpen(false);
  };
  const insertAttachment = (attachment) => {
    let slateTag;
    if (attachment.contentType === "video/mp4") {
      slateTag = `<div class="ckeditor-html5-video" style="text-align: center;"><video controls crossOrigin="use-credentials"  controlslist="nodownload" src="https://%%KPS_API_LOCATION%%/attachmentservice/attachment/${
        attachment.id
      }/content/">&nbsp;</video></div>`;
      // slateTag = `<div class="ckeditor-html5-video" style="text-align: center;"><video controls  controlslist="nodownload" src="https://${apiLocation}/attachmentservice/attachment/${
      //   attachment.id
      // }/content/?access_token=${accessToken}">&nbsp;</video></div>`;
    } else if (attachment.contentType === "application/pdf") {
      editor.insertHtml(
        `<div class="pdf-container" style="height: 700px; overflow: auto; position: relative;" id=docCtr-${attachment.id} data-attachment=${attachment.id}>` +
        `<div id=ctr-${attachment.id}>` +
        '<div class="pdfViewer" />' +
        "</div>" +
        "</div>",
       // `<div id=docCtr-${attachment.id.toString()} data-attachment=${attachment.id.toString()}></div>`
      );
      editor.execCommand("pdfviewer", {
        startupData: { attachmentId: attachment.id },
      });
      props.newPdf && props.newPdf(attachment.id);
      getPdfsForContent();
    } else if (attachment.contentType.includes("image")) {
      slateTag = `<img crossOrigin="use-credentials" alt src="https://%%KPS_API_LOCATION%%/attachmentservice/attachment/${
        attachment.id
      }/content/" />`;
      // slateTag = `<img alt src="https://${apiLocation}/attachmentservice/attachment/${
      //   attachment.id
      // }/content/?access_token=${accessToken}" />`;
    }
    editor.insertHtml(slateTag);
    setGlobalAttachmentsOpen(false);
  };
  const attachFile = (attachmentId, contentType, title) => {
    if (title) {
      // download link
      editor.insertHtml(
        `<a href="https://%%KPS_API_LOCATION%%/attachmentservice/attachment/${attachmentId}/content" 
        data-attachment=${attachmentId} 
        crossOrigin="use-credentials"
        class="file-attachment file-attachment-download">${title}</a>`
      );
    } else {
      // pdf to display
      editor.execCommand("pdfviewer", { startupData: { attachmentId } });
      props.newPdf && props.newPdf(attachmentId);
      getPdfsForContent();
    }
    setAttachFileOpen(false);
  };

  const generatePdfViewer = async (attachmentId, data) => {
    if(!pdfjsLib.GlobalWorkerOptions.workerPort) pdfjsLib.GlobalWorkerOptions.workerPort = new PdfjsWorker();
   // pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    let buffer = await data.arrayBuffer();
    let internalDocument = document;
    if (!props.readOnly) {
      internalDocument = editor.document.$;
    }
    let eventBus = new viewer.EventBus();
    let pdfLinkService = new viewer.PDFLinkService({ externalLinkTarget: 2, eventBus: eventBus });
    pdfjsLib.externalLinkTarget = pdfjsLib.LinkTarget.BLANK;
    let pdfFindController = new viewer.PDFFindController({
      eventBus: eventBus,
      linkService: pdfLinkService,
    });
    // let container = null;
    let container = internalDocument.querySelector(
      "div#docCtr-" + attachmentId
    );
    let containerParent = document.getElementById(`editor-${editorId}`);
    // if (containerParent) {
    //   container = containerParent.firstChild;
    // }
    if (container && container.firstChild) {
      let pdfViewer = new viewer.PDFViewer({
        eventBus: eventBus,
        container: container,
        linkService: pdfLinkService,
        findController: pdfFindController,
        textLayerFactory: new viewer.DefaultTextLayerFactory(),
        annotationLayerFactory: new viewer.DefaultAnnotationLayerFactory(),
        textLayerMode: props.readOnly ? 2 : 0,
      });
      pdfLinkService.setViewer(pdfViewer);

      let loadingTask = pdfjsLib.getDocument({
        data: buffer,
        disableAutoFetch: false,
      });

      loadingTask.promise.then(
        function(pdf) {
          pdfViewer.setDocument(pdf);
          pdfLinkService.setDocument(pdf, null);
          pdfFindController.setDocument(pdf, null);

          eventBus._on("pagerendered", (e, args) => {
                  const container = internalDocument.querySelector(
                "#docCtr-" + attachmentId
              );
              if (container) {
                const pages = container.querySelectorAll("div > div.page");
                pages.forEach((page) => {
                  const canvas = page.querySelector(
                    "div.canvasWrapper > canvas"
                  );
                  const textLayer = page.querySelector("div .textLayer");
                  if (textLayer) {
                    textLayer.style.top = canvas.offsetTop + "px";
                    textLayer.style.left = canvas.offsetLeft + "px";
                    textLayer.style.height = canvas.offsetHeight + "px";
                    textLayer.style.width = canvas.offsetWidth + "px";
                  }
                  const annotationLayer = page.querySelector(
                    "div .annotationLayer"
                  );
                  if (annotationLayer) {
                    annotationLayer.style.top = canvas.offsetTop + "px";
                    annotationLayer.style.left = canvas.offsetLeft + "px";
                    annotationLayer.style.height = canvas.offsetHeight + "px";
                    annotationLayer.style.width = canvas.offsetWidth + "px";
                  }
                });
              }
          });
        }.bind(this)
      );
    }
  };
  return (
    <div
      style={{
        alignSelf: "flex-end",
        margin: "auto",
        justifyContent: "flex-end",
        flex: 1,
      }}
      aria-label="Text editor"
    >
      {!props.readOnly &&
        loading && (
          <div style={{ textAlign: "center" }}>
            <CircularProgress size={20} /> Getting the editor ready...
          </div>
        )}
      {/* {(props.readOnly && data && data.includes("uks-chart")) && (
          <Button onClick={() => {
            processCharts()
            // setReportDialogOpen(true);
          }}>
            Refresh
          </Button>
      )}  */}
      {props.readOnly ? (
        <div
          id={`editor-${editorId}`}
          // dangerouslySetInnerHTML={{ __html: data }}
          style={{ height: "100%" }}
          ref={myElement}
        >
          <Highlight innerHTML={true}>
            {data}
          </Highlight>
        </div>
      ) : (
        <div style={{ display: loading ? "none" : "" }}>
          <CKEditor
            initData={props.initialContent ? processAPILocation(props.initialContent,false) : data}
            onInstanceReady={(e) => {
              setLoading(false);
              setEditor(e.editor);
              if (props.initialContent) {
                processAPILocation(props.initialContent, true);
               // processAccessToken(props.initialContent);
              }
            }}
            onFocus={() => props.editorFocused(editorId)}
            onChange={onChange}
            readOnly={props.readOnly}
            onFileUploadRequest={fileUpload}
            onFileUploadResponse={fileUploadResponse}
            onAfterCommandExec={commandExec}
            onBeforeLoad={(CKEDITOR) => {
              CKEDITOR.plugins.addExternal(
                "a11yhelp",
                "/ckeditor/plugins/a11yhelp/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "addr",
                "/ckeditor/plugins/addr/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "about",
                "/ckeditor/plugins/about/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "autocomplete",
                "/ckeditor/plugins/autocomplete/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "autoembed",
                "/ckeditor/plugins/autoembed/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "autolink",
                "/ckeditor/plugins/autolink/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "balloonpanel",
                "/ckeditor/plugins/balloonpanel/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "balloontoolbar",
                "/ckeditor/plugins/balloontoolbar/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "button",
                "/ckeditor/plugins/button/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "clipboard",
                "/ckeditor/plugins/clipboard/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "codesnippet",
                "/ckeditor/plugins/codesnippet/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "colorbutton",
                "/ckeditor/plugins/colorbutton/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "colordialog",
                "/ckeditor/plugins/colordialog/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "copyformatting",
                "/ckeditor/plugins/copyformatting/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "customfields",
                "/ckeditor/plugins/customfields/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "dialog",
                "/ckeditor/plugins/dialog/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "dialogui",
                "/ckeditor/plugins/dialogui/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "div",
                "/ckeditor/plugins/div/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "embed",
                "/ckeditor/plugins/embed/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "emoji",
                "/ckeditor/plugins/emoji/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "exportpdf",
                "/ckeditor/plugins/exportpdf/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "find",
                "/ckeditor/plugins/find/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "floatpanel",
                "/ckeditor/plugins/floatpanel/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "font",
                "/ckeditor/plugins/font/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "forms",
                "/ckeditor/plugins/forms/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "htmlwriter",
                "/ckeditor/plugins/htmlwriter/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "iframe",
                "/ckeditor/plugins/iframe/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "image",
                "/ckeditor/plugins/image/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "justify",
                "/ckeditor/plugins/justify/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "lineutils",
                "/ckeditor/plugins/lineutils/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "link",
                "/ckeditor/plugins/link/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "listblock",
                "/ckeditor/plugins/listblock/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "liststyle",
                "/ckeditor/plugins/liststyle/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "magicline",
                "/ckeditor/plugins/magicline/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "notification",
                "/ckeditor/plugins/notification/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "pagebreak",
                "/ckeditor/plugins/pagebreak/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "panelbutton",
                "/ckeditor/plugins/panelbutton/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "pastefromgdocs",
                "/ckeditor/plugins/pastefromgdocs/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "pastefromglibreoffice",
                "/ckeditor/plugins/pastefromglibreoffice/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "pastefromword",
                "/ckeditor/plugins/pastefromword/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "pastetools",
                "/ckeditor/plugins/pastetools/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "preview",
                "/ckeditor/plugins/preview/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "richcombo",
                "/ckeditor/plugins/richcombo/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "sayt",
                "/ckeditor/plugins/sayt/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "showblocks",
                "/ckeditor/plugins/showblocks/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "smiley",
                "/ckeditor/plugins/smiley/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "specialchar",
                "/ckeditor/plugins/specialchar/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "table",
                "/ckeditor/plugins/table/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "tableselection",
                "/ckeditor/plugins/tableselection/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "tabletools",
                "/ckeditor/plugins/tabletools/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "templates",
                "/ckeditor/plugins/templates/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "textmatch",
                "/ckeditor/plugins/textmatch/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "textwatcher",
                "/ckeditor/plugins/textwatcher/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "undo",
                "/ckeditor/plugins/undo/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "uploadimage",
                "/ckeditor/plugins/uploadimage/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "uploadwidget",
                "/ckeditor/plugins/uploadwidget/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "widget",
                "/ckeditor/plugins/widget/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "html5video",
                "/ckeditor/plugins/html5video/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "wordcount",
                "/ckeditor/plugins/wordcount/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "documentlink",
                "/ckeditor/plugins/documentlink/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "attachfile",
                "/ckeditor/plugins/attachfile/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "globalattachments",
                "/ckeditor/plugins/globalattachments/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "customfields",
                "/ckeditor/plugins/customfields/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "pdfviewer",
                "/ckeditor/plugins/pdfviewer/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "graph",
                "/ckeditor/plugins/graph/",
                "plugin.js"
              );
              CKEDITOR.plugins.addExternal(
                "image2",
                "/ckeditor/plugins/image2/",
                "plugin.js"
              );
            }}
            config={{
              toolbar: props.simpleToolbar ? simpleToolbar : fullToolbar,
              extraPlugins:
                "embed,autoembed,balloontoolbar,font,emoji,find,codesnippet,justify,colorbutton,documentlink,wordcount,html5video,attachfile,globalattachments,customfields,pdfviewer,graph,image2",
              removePlugins: "image,about",
              uploadUrl: `https://${apiLocation}/attachmentservice/attachment/upload/?type=Image`,
              filebrowserUploadUrl: `https://${apiLocation}/attachmentservice/attachment/upload/`,
              allowedContent: true,
              extraAllowedContent: "*(*);*{*}",
              embed_provider:
                "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
              resize_enabled: props.resize,
              autoParagraph: false,
              codeSnippet_theme: 'monokai',
            }}
          />
        </div>
      )}

      {documentDialogOpen && (
        <DocumentLinkDialog
          edit={documentLinkEdit}
          open={documentDialogOpen}
          onClose={() => {
            setDocumentDialogOpen(false);
            setDocumentLinkEdit(null);
          }}
          onSubmit={insertDocumentLink}
          onSubmitEdit={editDocumentLink}
        />
      )}
      {globalAttachmentsOpen && (
        <GlobalAttachmentsDialog
          open={globalAttachmentsOpen}
          onClose={() => {
            setGlobalAttachmentsOpen(false);
          }}
          onSubmit={insertAttachment}
        />
      )}
      {customFieldsDialogOpen && (
        <CustomFieldsDialog
          // edit={customFieldsEdit}
          open={customFieldsDialogOpen}
          // customFieldsChange={(customFields) => setCustomFieldsSelected(customFields)}
          onClose={() => {
            setCustomFieldsDialogOpen(false);
            // setDocumentLinkEdit(null);
          }}
          onSubmit={insertCustomFieldsLink}
          // onSubmitEdit={editCustomFields}
        />
      )}
      {customFieldsEdit && (
        <Dialog
          open={customFieldsEdit}
          onClose={() => setCustomFieldsEdit(false)}
        >
          <CreateCustomField
            selectedForEdit={props.currentCustomFields.filter((cf) => cf.tempId.toString() === customFieldSelected)[0]}
            //selectedForEdit={customFieldSelected}
            editInEditor
            close={() => setCustomFieldsEdit(false)}
            editCustomField={editCustomField}
          />
        </Dialog>
      )}
      {reportDialogOpen && (
        <ChartGeneratorDialog
          edit={!!reportEdit}
          chart={reportEdit}
          onSubmit={insertChart}
          onSubmitEdit={editChart}
          open={reportDialogOpen}
          onClose={() => {
            setReportDialogOpen(false);
            setReportEdit(null);
          }}
        />
      )}

      {attachFileOpen && (
        <AttachFileDialog
          updateUploadArray={props.updateUploadArray}
          open={attachFileOpen}
          onClose={() => setAttachFileOpen(false)}
          onSubmit={attachFile}
        />
      )}

      {queryParametersOpen && (
        <QueryParametersDialog
          open={queryParametersOpen}
          onClose={() => setQueryParametersOpen(false)}
          params={getQueryParams()}
          setQueryParams={setQueryParams}
        />
      )}
    </div>
  );
}

const fullToolbar = [
  {
    name: "clipboard",
    items: [
      "Cut",
      "Copy",
      "Paste",
      "PasteText",
      "PasteFromWord",
      "-",
      "Undo",
      "Redo",
    ],
  },
  { name: "editing", items: ["Find", "Replace", "-", "Scayt"] },
  { name: "links", items: ["Link", "Unlink", "Anchor"] },
  {
    name: "insert",
    items: [
      // "CreatePlaceholder",
      "Image",
      "CodeSnippet",
      // "Embed",
      "Table",
      "HorizontalRule",
      "SpecialChar",
      "EmojiPanel",
      "Html5video",
      "DocumentLink",
      "AttachFile",
      "GlobalAttachments",
      "CustomFields",
      "Graph",
    ],
  },
  { name: "tools", items: ["Maximize"] },
  // { name: "document", items: ["Source"] },
  "/",
  {
    name: "basicstyles",
    items: ["Bold", "Italic", "Underline", "Strike", "-", "RemoveFormat"],
  },
  {
    name: "paragraph",
    items: [
      "NumberedList",
      "BulletedList",
      "-",
      "Outdent",
      "Indent",
      "-",
      "Blockquote",
      "-",
      "JustifyLeft",
      "JustifyCenter",
      "JustifyRight",
      "JustifyBlock",
    ],
  },
  {
    name: "styles",
    items: ["Styles", "Format", "Font", "FontSize"],
  },
  { name: "colors", items: ["TextColor", "BGColor"] },
  { name: "about", items: ["About"] },
];

const simpleToolbar = [
  { name: "links", items: ["Link", "Unlink"] },
  {
    name: "insert",
    items: [
      "Image",
      "Html5video",
      "Table",
      "DocumentLink",
      "AttachFile",
      "GlobalAttachments",
      "CustomFields",
      "Abbr",
    ],
  },
  { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
  { name: "paragraph", items: ["NumberedList", "BulletedList"] },
  { name: "styles", items: ["Format", "Font", "FontSize"] },
];

const mapStateToProps = (state) => ({
  tempId: state.customFields.tempId,
  currentCustomFields: state.customFields.currentCustomFields,
  copiedContent: state.editor.copiedContent,
  editorId: state.editor.editorId,
  copyClicked: state.editor.copyClicked,
  currentUser: state.user.currentUser,
});
const mapDispatchToProps = {
  setTempId,
  setCustomFields,
  deleteCustomField,
  addOpen,
  removeOpen,
  editorFocused,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KpsEditor);
